<template>
  <span v-if="materialData && materialData.length">
    <div class="titlesection">{{consignee.name}}</div>
    <div class="row align-items-center" v-if="!isPerTrip">
      <div class="col-auto">
        <div class="titlesection_info">
          Individual freight for materials
          <span v-if="!configRunSection && materialData[0].bifurcation_by">
            ,based on
            <b>{{materialData[0].bifurcation_by}}</b>
          </span>
        </div>
      </div>
      <div class="col right-auto" v-if="consignee.freightRate">
        <div class="titlesection_sectitle">
          Charge ({{consignee.greaterValue}}
          * rate)
        </div>
        <div class="titlesection_amount">{{consignee.freightRate}}</div>
      </div>
    </div>
    <div class="tablesection rightalignrow">
      <TableHeader :headers="materialHeaders" :toolTipMapping="consignee.toolTipObj" />
      <TableRow
        v-for="(material, imx) in materialData"
        :key="imx"
        :data="material"
        :headers="materialHeaders"
      />
      <TableFooter
        v-if="!isPerTrip"
        :headers="materialHeaders"
        :data="consolidatedMatData(materialData)"
      />
    </div>
  </span>
</template>
<script>
import { materialHeader } from '@/constants/freight-working';
import TableHeader from '../../freight/Calculations/TableHeader';
import TableFooter from '../../freight/Calculations/TableFooter';
import TableRow from '../../freight/Calculations/TableRow';

export default {
  props: ['consignee', 'materialData', 'isPerTrip', 'configRunSection', 'config'],
  components: {
    TableHeader,
    TableFooter,
    TableRow,
  },

  data() {
    return {
      materialHeader,
    };
  },

  computed: {
    materialHeaders() {
      return this.materialHeader.filter((header) => {
        if (header.config) {
          return this.config[header.config];
        }
        return true;
      });
    },
  },

  methods: {
    consolidatedMatData(materials) {
      const sum = materials.reduce((acc, val) => {
        acc += Number.parseFloat(val.sum); // eslint-disable-line no-param-reassign
        return acc;
      }, 0);
      return { sum: `Total: Rs.${sum}` };
    },
  },
};
</script>
